import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["Media"] */ "/var/www/ouinex.com/frontend/src/app/[locale]/(home)/_component/FOKTrade/Media.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/app/[locale]/(home)/_component/vars.scss");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/app/[locale]/(home)/_component/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/blocks/Spotlight/SpotlightWithSlider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/Calculators/BuyCryptoCalculator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/Calculators/EarnCalculator.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/components/NavigationLink.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/components/ResponsiveImage.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/components/Swiper/Swiper.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/var/www/ouinex.com/frontend/src/components/ui/accordion.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea","ScrollBar"] */ "/var/www/ouinex.com/frontend/src/components/ui/scroll-area.jsx");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/components/ui/separator.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/var/www/ouinex.com/frontend/src/components/ui/tabs.jsx");
